export default __webpack_public_path__ + "static/media/presentation.87295172.jpg";